import axios from 'axios';
import Config from 'react-native-config';
import { normalizeAxiosError } from './utils/apiError';

const baseURL = Config.API_URL || process.env.API_URL;
// const baseURL = 'https://bizplus-test-server.bizpluspos.co.ke/';

console.log('baseURL', baseURL);

export const axiosinstance = axios.create({
  baseURL: baseURL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': true,
  },
});

export const axiosPrivate = axios.create({
  baseURL: baseURL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': true,
  },
});

// Dedicated axios for backoffice owner flows to isolate interceptors
export const axiosBackoffice = axios.create({
  baseURL: baseURL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': true,
  },
});

const rejectWithApiMessage = (error: unknown) =>
  Promise.reject(normalizeAxiosError(error));

axiosinstance.interceptors.response.use(
  response => response,
  rejectWithApiMessage,
);
axiosPrivate.interceptors.response.use(
  response => response,
  rejectWithApiMessage,
);
axiosBackoffice.interceptors.response.use(
  response => response,
  rejectWithApiMessage,
);
